import React from 'react';
import AttachFile from 'material-ui/svg-icons/editor/attach-file';
import moment from 'moment';
import NotDoneIcon from 'material-ui/svg-icons/action/assignment-return';
import { FontIcon } from 'material-ui';


export default ({ isHovered, hoveredDone, toggleDone, conv, markAsDone }) => (
  <div className="flex-tc-sb" style={{ height: '24px', lineHeight: '24px', overflow: 'hidden' }}>
    {
      isHovered ? (
        <div
          style={{ fontSize: '12px', color: hoveredDone ? '#1F8CEB' : '', display: 'flex', alignItems: 'center' }}
          onMouseEnter={() => toggleDone(true)}
          onMouseLeave={() => toggleDone(false)}
          onClick={(e) => {
            e.stopPropagation();
            markAsDone(conv.messageId, !conv.archived);
          }}
        >
          {conv.archived ? (<NotDoneIcon
            color={hoveredDone ? '#1F8CEB' : 'grey'}
            style={{ height: '18px', width: '18px' }}
          />) : (<FontIcon
            className="tc-icon-check"
            color={hoveredDone ? '#1F8CEB' : 'grey'}
            style={{ fontSize: '18px' }}
          />)}
          {conv.archived ? 'Reopen' : 'Done'}
        </div>
      ) : (
        <div style={{ fontSize: '12px', color: conv.hasSeen ? 'grey' : '#00bcd4', display: 'flex', alignItems: 'center' }}>
          {conv.attachements && conv.attachments.length ? <AttachFile style={{ height: '16px', color: 'grey' }}/> : null}
          {/*{conv.hasSeen ? null : <div style={{ backgroundColor: '#00bcd4', width: '10px', height: '10px', borderRadius: '50%', marginRight: '4px' }} />}*/}
          {moment(conv.createdAt).calendar(null, {
            sameDay: '[Today]',
            lastDay: 'DD/MM/YYYY',
            lastWeek: 'DD/MM/YYYY',
            sameElse: 'DD/MM/YYYY',
          })}
        </div>
      )
    }
  </div>
);



// WEBPACK FOOTER //
// ./src/app/components/messaging/conversations/timeNWidget.jsx